const IS_PRODUCTION = true;
const Config = {
    PRODUCTION: IS_PRODUCTION,
    EDUPARX_SITE: IS_PRODUCTION ? 'https://eduparx.id' : 'https://eduparx.dev.siapkampusmerdeka.id' ,
    BASE_API: IS_PRODUCTION ? 'https://api.eduparx.id/x1' : 'https://asmapi.dev.siapkampusmerdeka.id',
    BASE_API_2: IS_PRODUCTION ? 'https://api.eduparx.id/x2' : 'https://asmapi2.dev.siapkampusmerdeka.id',
};

export default Config;